import { useEffect } from "react";

/**
 * Custom hook to set the document title dynamically
 * @param title - The page title (will be appended with " | iGROWth")
 */
export function usePageTitle(title: string) {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title ? `${title} | iGROWth` : "iGROWth";

    return () => {
      document.title = previousTitle;
    };
  }, [title]);
}

export default usePageTitle;
